import type { RouterHistory } from 'vue-router'

export function useRouterHistory() {
  return inject('history') as RouterHistory
}
